import { render, staticRenderFns } from "./ChatEmotionReadOnly.vue?vue&type=template&id=b5d1d9c2&scoped=true"
import script from "./ChatEmotionReadOnly.vue?vue&type=script&lang=js"
export * from "./ChatEmotionReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotionReadOnly.vue?vue&type=style&index=0&id=b5d1d9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d1d9c2",
  null
  
)

export default component.exports